import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ActivationHelper } from '../activation/activation.helper'

import { environment } from 'src/environments/environment';

// service
import { JwtHelperService } from '@auth0/angular-jwt'

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  platform = navigator.platform;
  userAgent = navigator.userAgent;
  boxTeleIdea = this.userAgent.toLocaleLowerCase().indexOf('teleidea') != -1;
  boxBrowserQT = this.userAgent.toLocaleLowerCase().indexOf('qtsimplebrowser') != -1;


  boxModel!: string;
  versionFW!: string;
  caid!: string;

  constructor(
    private http: HttpClient,
    private router: Router,
  ) { }

  public sign(paylood: any): Observable<any>{

    // Retorna o token Jwt
    return this.http.post<{AccessToken: string}>(`${environment.apiUrl}/api/Device/Authenticate/Guid`, paylood).pipe(
      map((res) => {

        localStorage.setItem('AccessToken', res.AccessToken)
        return this.router.navigate(['/home'])
      })
    )
  }

  public isAuthenticated(): boolean{
    const token = localStorage.getItem("AccessToken");
    // TODO: quanto ativar o modo de produção com a claro trocar para false
    if(!token) return true;

    const jwtHelper = new JwtHelperService();
    return !jwtHelper.isTokenExpired(token);
  }

  public getQrCode(): Observable<any>{
    let access={}
    if(ActivationHelper.getSavedGuid()){
      access = {'DeviceGuid': ActivationHelper.getSavedGuid(), 'DeviceHeader': ActivationHelper.getSaveUserAgent()}
    }
    return this.http.post(`${environment.apiUrl}/api/Device/Authenticate/Guid`, access);
  }

  public isBox(): boolean {
    let box: boolean = false;

    if(this.boxTeleIdea) box = true

    if(this.boxBrowserQT) box = true

    return box
  }

  public infoBox(): void {
    function guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
          return v.toString(16);
      });
    }
    ActivationHelper.saveLastGuid(guid())

    const infoBox = this.platform+'-'+this.userAgent
    ActivationHelper.saveUserAgent(infoBox);
  }

  public statuspayingsubscriber():Observable<any>{
    const code =localStorage.getItem('QRCode')
    return this.http.get(`${environment.apiUrl}/api/Device/Authenticate/Code/${code}/Status`)
  }

  public resetPassword(): any{
    for(let i=0 ; i<localStorage.length; i++){
      //console.log('localstorege: ++++++ ',localStorage.key(i),' : ', localStorage.getItem(String(localStorage.key(i))))
      if(localStorage.getItem('restPasswordOne') == 'one' && localStorage.getItem('restPasswordFive') == 'five' && localStorage.getItem('restPasswordNine') == 'nine'){

        localStorage.clear();
      }
    }
  }

}
